import { Navigate, Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext.jsx'
import { usePeptides } from '../context/PeptidesContext.jsx'
import Seo from './Seo.jsx'

// Gate for admin-only pages: waits for auth, redirects logged-out users to
// login, and shows a friendly notice for signed-in non-admins.
export default function RequireAdmin({ children }) {
  const { user, initializing } = useAuth()
  const { isAdmin } = usePeptides()

  if (initializing) {
    return (
      <main className="page"><Seo noindex /><div className="container center" style={{ padding: '80px 0' }}><div className="spinner" /></div></main>
    )
  }
  if (!user) return <Navigate to="/login" replace state={{ from: '/admin' }} />
  if (!isAdmin) {
    return (
      <main className="page">
        <Seo noindex />
        <div className="container center" style={{ padding: '60px 0' }}>
          <div style={{ fontSize: '2.4rem', marginBottom: 8 }}>🔒</div>
          <h1 className="section-title">Admins only</h1>
          <p className="section-sub">This account isn’t an admin. Add yourself in Supabase (see <code>supabase/peptides.sql</code>).</p>
          <Link to="/" className="btn btn-primary">Back home</Link>
        </div>
      </main>
    )
  }
  return children
}
